import { environment } from "environments/environment";

type InstrumentedFetch = typeof fetch & { __original?: typeof fetch };

const startSessionReplay = (): void => {
  const options: SessionReplayOptions = {
    host: environment.oneUptime.host,
    token: environment.oneUptime.token,
    // Replay carries no environment attribute, so the identifier keeps the environments apart.
    appIdentifier: environment.oneUptime.serviceName,
  };

  window.__ONEUPTIME_SESSION_REPLAY__ = options;

  const script: HTMLScriptElement = document.createElement("script");
  script.src = `${options.host}/telemetry/session-replay/v1/recorder.js`;
  script.async = true;
  script.crossOrigin = "anonymous";
  // OTLP exports call fetch.__original to skip instrumentation, so the recorder's wrapper must carry one too.
  const bypass: typeof fetch = (window.fetch as InstrumentedFetch).__original ?? window.fetch;
  let current: InstrumentedFetch = window.fetch;
  Object.defineProperty(window, "fetch", {
    configurable: true,
    enumerable: true,
    get: (): InstrumentedFetch => current,
    set(this: object, next: InstrumentedFetch): void {
      // Ponyfills such as cross-fetch assign fetch on an object that inherits from window; give them their own property.
      if (this !== window) {
        Object.defineProperty(this, "fetch", { configurable: true, enumerable: true, writable: true, value: next });
        return;
      }

      if (typeof next === "function") {
        next.__original ??= bypass;
      }
      current = next;
    },
  });

  document.head.appendChild(script);
};

try {
  // A hidden auth iframe can boot a second copy of the SPA; recording it wastes a session.
  if (window.self === window.top) {
    startSessionReplay();
  }
} catch (error) {
  // Replay failing must never take the app down.
  console.error("OneUptime session replay failed to start; continuing without it.", error);
}
